import React, { useState } from 'react';
import { createOrderApi } from '../../utils/orderApi';
import '../css/Category.css';

const OrderCreate = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({
    UserId: '',
    AddressId: '',
    CartId: '',
    OrderStatus: 'Ordered',
    PaymentStatus: 'Pending',
    SubTotal: '0',
    DiscountAmount: '0',
    ShippingAmount: '0',
    TaxAmount: '0',
    TotalAmount: '0',
    Notes: '',
  });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!form.UserId || !form.AddressId) {
      setFormError('UserId and AddressId are required.');
      return;
    }
    setSaving(true);
    setFormError(null);
    try {
      await createOrderApi({
        UserId: Number(form.UserId),
        AddressId: Number(form.AddressId),
        CartId: form.CartId ? Number(form.CartId) : null,
        OrderStatus: form.OrderStatus,
        PaymentStatus: form.PaymentStatus,
        SubTotal: Number(form.SubTotal) || 0,
        DiscountAmount: Number(form.DiscountAmount) || 0,
        ShippingAmount: Number(form.ShippingAmount) || 0,
        TaxAmount: Number(form.TaxAmount) || 0,
        TotalAmount: Number(form.TotalAmount) || 0,
        Notes: form.Notes.trim() || null,
      });
      onSuccess('Order created successfully.');
    } catch (e) {
      setFormError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cat-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cat-modal" style={{ maxWidth: 640 }}>
        <div className="cat-modal-header">
          <h5>Add Order</h5>
          <button type="button" className="cat-modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="cat-modal-body">
          {formError && <div className="alert alert-danger py-2 mb-3">{formError}</div>}
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">User ID *</label>
              <input className="form-control" name="UserId" value={form.UserId} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Address ID *</label>
              <input className="form-control" name="AddressId" value={form.AddressId} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Cart ID</label>
              <input className="form-control" name="CartId" value={form.CartId} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Order Status</label>
              <input className="form-control" name="OrderStatus" value={form.OrderStatus} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Payment Status</label>
              <input className="form-control" name="PaymentStatus" value={form.PaymentStatus} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Sub Total</label>
              <input className="form-control" name="SubTotal" value={form.SubTotal} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Tax Amount</label>
              <input className="form-control" name="TaxAmount" value={form.TaxAmount} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Total Amount</label>
              <input className="form-control" name="TotalAmount" value={form.TotalAmount} onChange={handleChange} />
            </div>
            <div className="col-12">
              <label className="form-label">Notes</label>
              <textarea className="form-control" name="Notes" value={form.Notes} onChange={handleChange} rows={2} />
            </div>
          </div>
        </div>
        <div className="cat-modal-footer">
          <button type="button" className="btn btn-light me-2" onClick={onClose}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderCreate;
